import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { ProfileOutlined, SearchOutlined } from '@ant-design/icons/lib';
import { Breadcrumb, Col, Row } from 'antd';
import { noop } from 'lodash';
import { httpCreators, useLoadingSelector } from 'rbh-merchant-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { generalCreators } from '../../../redux/general/general-action';
import { DEFAULT_PAGE_SIZE, MODAL_TYPE } from '../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../redux/general/general-reducer';
import { RBHAlert, RBHBox, RBHButton, RBHError, RBHTable, RBHText, RBHTextInput } from '../../../shared/components';
import styleButton from '../../../shared/components/rbh-button/styles';
import styleImage from '../../../shared/components/rbh-image/styles';
import styleText from '../../../shared/components/rbh-text/styles';
import styleInput from '../../../shared/components/rbh-textinput/styles';
import { Colors, Images } from '../../../shared/theme';
import metrics from '../../../shared/theme/metrics';
import { mainCreators } from '../../main-action';
import { MAIN_STATE_KEY } from '../../main-reducer';
import stylesCat from '../FoodCategory/styles';
import { FormAddEdit } from './components/FormAddEdit';
import { catCreators } from './redux/cat-action';
import { CAT_REQUEST_ID_LIST } from './redux/cat-constant';
import { AlertData, CAT_STATE_KEY, catStateSelector } from './redux/cat-reducer';
import { catSagas } from './redux/cat-saga';
import { CatService } from './redux/cat-service';
import stylesHead from './styles';
import './stylescss.css';

export const FoodCategoryScreen: React.FC<Props> = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(catStateSelector(CAT_STATE_KEY.LIST)) as [];
  const alertSuccessData = useSelector(catStateSelector(CAT_STATE_KEY.ALERT_SUCCESS)) as AlertData;
  const alertFailureData = useSelector(catStateSelector(CAT_STATE_KEY.ALERT_FAILURE)) as AlertData;
  const loading = useLoadingSelector(CAT_REQUEST_ID_LIST.GET_CAT);
  const [edit, setEdit] = useState(null);

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 4));
    resetReload();
  }, []);

  const pushToCat = () => {
    resetReload();
  };

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setEdit(null);
    dispatch(catCreators.callFoodCategory(noop, true));
  };

  const toAddCat = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/addfoodcategory');
  };

  const pushToMain = () => {
    history.push('/main');
  };

  const onDelete = (id: any) => {
    dispatch(httpCreators.request({
      id: CAT_REQUEST_ID_LIST.DELETE_CAT,
      sagaHandler: catSagas.deleteCatHandler as any,
      callbackParams: resetReload,
      service: CatService.deleteCat,
      serviceParams: id
    }));
  };

  const columns = [
    {
      width: metrics.tableHeader.width725,
      className: 'cat-search-header',
      title: <FormattedMessage id={'main.cat_category_name'} />,
      dataIndex: 'menuCategoryName',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => {
        return (
          <RBHBox style={stylesCat.searchBox}>
            <RBHTextInput
              placeholder={'main.cat_category_search_placeholder'}
              data-testid={'search-cat-input'}
              id='search-cat-input'
              style={styleInput.inputTableSearch}
              value={selectedKeys[0]}
              onChange={(e: any) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={confirm}
              onBlur={confirm}
            />
          </RBHBox>
        );
      },
      filterIcon: (filtered: any) => (
        <SearchOutlined data-testid={'search-cat-icon'} id='search-cat-icon' translate={null} style={{ color: filtered ? Colors.lightPurple : undefined }} />
      ),
      onFilter: (value: any, all: any) => {
        if (all.menuCategoryTypeId === 2) {
          return true;
        }
        return all.menuCategoryName.toString().toLowerCase().includes(value.toLowerCase());
      },
      onFilterDropdownVisibleChange: (visible: boolean) => {
        if (visible) {
          setTimeout(() => {
            const inputEl = document.getElementById('search-input');
            if (inputEl) {
              (inputEl as HTMLInputElement).select();
            }
          });
        }
      },
      render: (value: any, all: any, index: number) => {
        const menuCategoryName = 'menuCategoryName-' + index;
        const menuCategoryNameThStyle = all.menuCategoryTypeId === 2 ? stylesCat.textTableContent : styleText.textTableContent
        const menuCategoryNameEnStyle = all.menuCategoryTypeId === 2 ? stylesCat.promotionTextEN : styleText.textRegularGray
        return (
          <RBHBox id={menuCategoryName} style={{ width: metrics.tableHeader.width725 }}>
            <Row>
              {
                all.menuCategoryTypeId === 2 ?
                <Col>
                  <img src={Images.promotion} style={styleImage.iconS} />
                </Col> : null
              }
              <Col>
                <RBHText
                  id={`menuCategoryNameTH-${index}`} data-testid={`menuCategoryNameTH-${index}`}
                  style={menuCategoryNameThStyle}
                >
                  {all.menuCategoryName}
                </RBHText>
                <RBHText
                  id={`menuCategoryNameEN-${index}`} data-testid={`menuCategoryNameEN-${index}`}
                  style={menuCategoryNameEnStyle}
                >
                  {all.menuCategoryNameEN}
                </RBHText>
              </Col>
            </Row>
          </RBHBox>
        );
      }
    },
    {
      title: <FormattedMessage id={'main.edit'} />,
      align: 'center',
      render: (value: any, all: any, index: any) => {
        const categoryEdit = 'categoryEdit-' + index;
        return (all.menuCategoryTypeId === 2 ? null :
          <RBHBox onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setEdit(all);
          }}>
            <EditOutlined data-testid={categoryEdit} id={categoryEdit} translate={null} style={styleImage.iconTable} />
          </RBHBox>);
      },
    },
    {
      title: <FormattedMessage id={'main.vat.vatdelete'} />,
      align: 'center',
      dataIndex: 'menuCategoryId',
      render: (menuCategoryId: any, all: any, index: number) => {
        const categoryDelete = 'categoryDelete-' + index;
        return (all.menuCategoryTypeId === 2 ? null :
          <RBHBox onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
            visible: true,
            onOk: () => onDelete(menuCategoryId),
            modalTitle: 'main.cat_category_delete_header',
            modalContent: 'main.cat_category_delete_content',
            type: MODAL_TYPE.DELETE
          }))}>
            <DeleteOutlined data-testid={categoryDelete} id={categoryDelete} translate={null} style={styleImage.iconTable} />
          </RBHBox>
        );
      }
    }
  ];

  const AlertBar = () => {
    if (alertSuccessData?.isVisible) {
      return (
        <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
          <RBHAlert
            type={'success'}
            text={'main.cat_category.edit.alert.success'}
            values={alertSuccessData?.translationValues}
            autoCloseDuration={3000}
            afterClose={() => {
              dispatch(catCreators.setCatState(CAT_STATE_KEY.ALERT_SUCCESS, {
                isVisible: false,
                translationValues: {
                  categoryName: '???',
                },
              }));
            }}
          />
          <br />
        </RBHBox>
      );
    } else if (alertFailureData?.isVisible) {
      return (
        <RBHBox id={'alertFailure'} data-testid={'alertFailure'}>
          <RBHAlert
            type={'error'}
            text={'main.cat_category.edit.alert.failure'}
            values={alertFailureData?.translationValues}
            autoCloseDuration={3000}
            afterClose={() => {
              dispatch(catCreators.setCatState(CAT_STATE_KEY.ALERT_FAILURE, {
                isVisible: false,
                translationValues: {
                  categoryName: '???',
                },
              }));
            }}
          />
          <br />
        </RBHBox>
      );
    } else {
      return null;
    }
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'breadcrumb-cat-tohomepage'} id='breakcrumb-cat-tohomepage' style={styleText.breadCrumbItemLink} onClick={() => {
              history.push('/main');
            }}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'breadcrumb-cat'} id='breakcrumb-cat' style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.cat_category'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const BreadcrumbEditRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a id='breadcrumb-cat-edit-tohomepage' style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true, onOk: pushToMain, type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a id='breadcrumb-cat-edit-tolistcat' style={styleText.breadCrumbItemLink} onClick={() =>
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true, onOk: pushToCat, type: MODAL_TYPE.CONFIRM_EDIT
              }))}>
              <FormattedMessage id={'main.cat_category'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span id='breadcrumb-cat-edit' style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.cat_category_edit'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const TabRender = (props: any) => {
    return (
      <RBHBox style={stylesHead.header}>
        {props.textHeader ? <RBHText style={styleText.headerText} text={props.textHeader} data-testid={'cat_category'} id={'cat_category'} /> : null}
        {data === undefined || Object.keys(data).length <= 0 ? null
          : <RBHButton id={'cat_addcat'} style={styleButton.buttonAdd} text={'main.cat_addcat'} type='primary'
            onClick={toAddCat} icon={<ProfileOutlined translate={null} />}>
          </RBHButton>}
      </RBHBox>
    );
  };

  const TableRender = () => {
    return (
      <RBHTable rowKey={(record: { menuCategoryId: any; }) => record.menuCategoryId}
        loading={loading} columns={columns} dataSource={data}
        rowClassName={(record: any) => (record.menuCategoryTypeId === 2 ? 'tablePromotion' : null)}
        pagination={{
          showSizeChanger: false,
          pageSize: DEFAULT_PAGE_SIZE,
          position: ['bottomLeft'],
          hideOnSinglePage: true,
          showTotal: (total: number, range: number[]) => {
            return (<RBHText style={styleText.textPaginationShowTotal}>
              <FormattedMessage id={'main.showing'} />
              <span> {range[0] + '-' + range[1]} </span>
              <FormattedMessage id={'main.of'} />
              <span> {total}</span>
            </RBHText>);
          }
        }}>
      </RBHTable>
    );
  };

  return (
    <RBHBox>
      <AlertBar />
      {edit ? <BreadcrumbEditRender /> : <BreadcrumbRender />}
      {loading ? null :
        edit ?
          <RBHBox>
            <RBHBox style={stylesCat.header}>
              <RBHText style={styleText.headerText} text={'main.cat_category_edit'} data-testid={'cat_category_edit'} id={'cat_category_edit'} />
            </RBHBox>
            <RBHBox style={stylesCat.defaultContent}>
              <FormAddEdit editData={edit} onSuccessCallback={pushToCat} onCancel={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  onOk: pushToCat,
                  type: MODAL_TYPE.CONFIRM_EDIT
                }))}
                onNotificationError={pushToCat}
                />
            </RBHBox>
          </RBHBox>
          :
          <RBHBox>
            <TabRender textHeader={'main.cat_category'} />
            <RBHBox>
              {data === undefined ? <RBHError onOk={() => resetReload()} />
                : Object.keys(data).length <= 0 ? <RBHError onOk={() => resetReload()} />
                  : <RBHBox style={stylesCat.defaultContent}>
                    <TableRender />
                  </RBHBox>}
            </RBHBox>
          </RBHBox>
      }
    </RBHBox>
  );
};

type Props = {};
